import React, { Component } from "react";
import { connect } from "react-redux";
import Gravatar from "react-gravatar";
import Moment from "react-moment";
import "./index.css";
import { Label, Media } from "react-bootstrap";

class CommentCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTelemetry: false
    };
  }

  renderAuthorDiv = item => {
    let tempActionDisplay = "";
    if (item.action_display === "Assigned") {
      tempActionDisplay = item.action_display + " to " + item.assignee.display_name;
    } else if (item.action_display === "Merged Into" || item.action_display === "Merged In") {
      tempActionDisplay = item.action_display + " Note #" + item.merge_target;
    } else {
      tempActionDisplay = item.action_display;
    }

    return (
      <div className="author-div">
        {item.user.display_name}{" "}
        <span className="comment-time">
          <Moment format="DD MMM, hh:mm a">{item.created}</Moment>
        </span>
        {tempActionDisplay ? <Label className="action-display">{tempActionDisplay}</Label> : null}
      </div>
    );
  };

  renderCommentDiv = item => {
    return (
      <div className="comment-description">
        {item.comment ? item.comment : <span className="noComment">No Comment</span>}
      </div>
    );
  };

  renderGravatar = item => {
    return <Gravatar md5={item.user.email_md5} default="mp" />;
  };

  render = () => {
    const { item } = this.props;

    if (!item) {
      return null;
    }

    return (
      <div className="mainCommentCard">
        <div className="commentCard">
          <Media>
            <Media.Left>{this.renderGravatar(item)}</Media.Left>
            <Media.Body className="comment-div">
              {this.renderAuthorDiv(item)}
              {this.renderCommentDiv(item)}
            </Media.Body>
          </Media>
        </div>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  };
}

export default connect(mapStateToProps)(CommentCard);



// WEBPACK FOOTER //
// ./src/_components/CommentCard/index.js